import {IExchangeRate} from '../../types/models/Price';
import {
  FETCH_EXCHANGE_RATE,
  FETCH_EXCHANGE_RATE_ERROR,
  FETCH_EXCHANGE_RATE_SUCCESS,
} from '../../types/actions/ExchangeRate.actions';
import {ExchangeRateActionTypes} from '../../types/actions/ExchangeRate.actions';

export interface ExchangeRateState {
  data: IExchangeRate | null;
  isLoading: boolean;
}

const initialState: ExchangeRateState = {
  isLoading: false,
  data: null,
};

export default (
  state = initialState,
  action: ExchangeRateActionTypes,
): ExchangeRateState => {
  switch (action.type) {
    case FETCH_EXCHANGE_RATE: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case FETCH_EXCHANGE_RATE_SUCCESS: {
      return {
        isLoading: false,
        data: action.payload,
      };
    }
    case FETCH_EXCHANGE_RATE_ERROR: {
      return {
        isLoading: false,
        data: null,
      };
    }
    default:
      return state;
  }
};
